import { initLivraison } from '../../types/client/client.def';
import {
  CommandeStateUpdate,
  UpdateCommandeParams
} from '../../types/commande/formatUpdateCommande';

export const formatUpdateCommande = (
  cmdState: CommandeStateUpdate
): UpdateCommandeParams => {
  const horsLycee = cmdState.client.values.livraisonhorslycee;
  const pro = cmdState.client.values.clientpro;

  if (!horsLycee)
    cmdState.client.values = { ...cmdState.client.values, ...initLivraison };
  if (!pro)
    cmdState.client.values = { ...cmdState.client.values, nomsociete: null };
  return {
    id: cmdState.commande.id,
    numerocommande: cmdState.commande.numerocommande,
    totalttc: cmdState.totalNoPort,
    cmlToDelete: cmdState.cmlToDelete,
    fraislivraison: cmdState.currentFraisPort,
    methodepaiement: cmdState.commande.methodepaiement,
    customerContributedToTheOng: cmdState.commande.customerContributedToTheOng,
    prixTotal: cmdState.commande.prixTotal,
    status: cmdState.commande.status,
    client: cmdState.client.values,
    commandelines: cmdState.commandelines.map(cml => ({
      id: cml.id,
      quantite: cml.quantite,
      produit: cml.produit.id
    }))
  };
};
